import React, { lazy } from 'react'
import { ConversionRateListing } from './ConversionRateListing'
import { UploadValidationListing } from './UploadValidationListing'

const UOMListing = lazy(() =>
  import('./UOMListing').then(module => ({
    default: module.UOMListing,
  }))
)

// const UOMExchangeListing = lazy(() =>
//   import(
//     '@ifca-root//UOMExchange/UOMRateListing'
//   ).then(module => ({
//     default: module.UOMRateListing,
//   })),
// );

const uomRoutes = [
  {
    props: { exact: true, path: '/common-setting/uom' },
    component: <UOMListing />,
  },

  {
    props: {
      exact: true,
      path: '/common-setting/uom-conversion-rate',
    },
    component: <ConversionRateListing />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/uom/validation',
    },
    component: <UploadValidationListing />,
  },
]

export default uomRoutes
